import PropTypes from 'prop-types'
import React, { Component } from "react"
import { Alert, Card, CardBody, Col, Container, Row, FormGroup } from "reactstrap"

// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"

// action
import { apiError, userResetPassword } from "../../store/actions"

// import images
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo.png"

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    const resetToken = this.props.location.pathname.replace('/passwordreset/', '');
    const newValues= {"password": values.password, "confpassword": values.confpassword, "resetToken": resetToken};
    this.props.userResetPassword(newValues, this.props.history)
  //  if(values.password !== values.confpassword) {
    // this.props.resetError = ["Passwords do not match"];
  //   setPassword("");
  //   setConfPassword("");
  // return setTimeout(() => { this.props.resetError ="Passwords do not match"; }, 5000)
    // return this.props.apiError("Passwords do not match");
  //  }
  //  const resetToken = this.props.location.pathname.replace('/passwordreset/', '');
  //  const newValues= {"password": values.password, "resetToken": resetToken};
  //   if(values.password != values.confpassword){
  //     this.props.resetError = "Passwords do not match"
  //   } else {
  //     this.props.userResetPassword(newValues, this.props.history)
    // }
  }

  componentDidMount() {
    this.props.apiError("")
  }

  render() {
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2" />
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-5">
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p>Reset your password.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="auth-logo">
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-soft">
                            <img src={logo} alt="" className="" height="34" />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      {this.props.resetError && this.props.resetError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {this.props.resetError}
                        </Alert>
                      ) : null}
                      {this.props.resetSuccessMsg ? (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {this.props.resetSuccessMsg}
                        </Alert>
                      ) : null}

                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={this.handleValidSubmit}
                      >
                        <FormGroup className="mb-4">
                          <AvField
                            name="password"
                            label="New Password"
                            className="form-control"
                            placeholder="Enter new password"
                            type="password"
                            required
                          />
                        </FormGroup>
                        <FormGroup className="mb-4">
                          <AvField
                            name="confpassword"
                            label="Confirm Password"
                            className="form-control"
                            placeholder="Confirm New Password"
                            type="password"
                            required
                          />
                        </FormGroup>  
                        <div className="text-end">
                          <button
                            className="btn btn-primary w-md"
                            type="submit"
                          >
                            Reset
                            </button>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    Go back to{" "}
                    <Link
                      to="/login"
                      className="fw-medium text-primary"
                    >
                      Login
                    </Link>{" "}
                  </p>
                  <p>
                    © {new Date().getFullYear()} Korupharma. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger" /> by Us
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ResetPasswordPage.propTypes = {
  resetError: PropTypes.any,
  resetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userResetPassword: PropTypes.any
}

const mapStateToProps = state => {
  const { resetError, resetSuccessMsg } = state.ResetPassword
  return { resetError, resetSuccessMsg }
}

export default withRouter(
  connect(mapStateToProps, { userResetPassword, apiError })(ResetPasswordPage)
)
